import request from './request'

/**
 * 获取支付成功结果
 * @param {string} trade_no 订单号
 */
export function getPayCodeImage(data) {
  return request.get('/getPayCodeImage.php', {
    params: data
  })
}

/**
 * 循环查询是否支付了
 * @param {string} trade_no 订单号
 */
export function getPayResult(data) {
  return request.get('/getPayQuery3.php', {
    params: data
  })
}

/**
 * 查询推荐人手机号是否在有效期
 * @param {string} phone 手机号
 */
export function getPayPhoneInfo(data) {
  return request.get('/getPermissionPhoneInfo.php', {
    params: data
  })
}
